import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/** MetaMask (and similar) inject into every page; their failed auto-connect must not break login. */
function isExtensionWalletNoise(err) {
  const msg = String(err?.message || err?.reason || err || "");
  return /metamask|failed to connect to metamask|chrome-extension:\/\/nkbihfbeogaeaoehlefnkodbefgpgknn/i.test(
    msg
  );
}

window.addEventListener("unhandledrejection", (event) => {
  if (isExtensionWalletNoise(event.reason)) {
    event.preventDefault();
  }
});

window.addEventListener("error", (event) => {
  if (isExtensionWalletNoise(event.error || event.message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
